"use strict";
var gpml_utilities_1 = require("./gpml-utilities");
var LABEL_DEFAULTS = {
    attributes: {
        Align: {
            name: 'Align',
            value: 'Center'
        },
        Color: {
            name: 'Color',
            value: '000000'
        },
        FillColor: {
            name: 'FillColor',
            value: 'Transparent'
        },
        FontSize: {
            name: 'FontSize',
            value: 10
        },
        LineThickness: {
            name: 'LineThickness',
            value: 1
        },
        Padding: {
            name: 'Padding',
            value: '0.1em'
        },
        ShapeType: {
            name: 'ShapeType',
            value: 'None'
        },
        Valign: {
            name: 'Valign',
            value: 'Top'
        },
        ZOrder: {
            name: 'ZOrder',
            value: 0
        }
    }
};
function applyDefaults(gpmlElement, defaults) {
    return gpml_utilities_1.applyDefaults(gpmlElement, [LABEL_DEFAULTS, defaults]);
}
exports.applyDefaults = applyDefaults;
;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGFiZWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvbGFiZWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLG1EQUFzRTtBQUV0RSxJQUFNLGNBQWMsR0FBRztJQUN0QixVQUFVLEVBQUU7UUFDWCxLQUFLLEVBQUU7WUFDTixJQUFJLEVBQUUsT0FBTztZQUNiLEtBQUssRUFBRSxRQUFRO1NBQ2Y7UUFDRCxLQUFLLEVBQUU7WUFDTixJQUFJLEVBQUUsT0FBTztZQUNiLEtBQUssRUFBRSxRQUFRO1NBQ2Y7UUFDRCxTQUFTLEVBQUU7WUFDVixJQUFJLEVBQUUsV0FBVztZQUNqQixLQUFLLEVBQUUsYUFBYTtTQUNwQjtRQUNELFFBQVEsRUFBRTtZQUNULElBQUksRUFBQyxVQUFVO1lBQ2YsS0FBSyxFQUFDLEVBQUU7U0FDUjtRQUNELGFBQWEsRUFBRTtZQUNkLElBQUksRUFBRSxlQUFlO1lBQ3JCLEtBQUssRUFBRSxDQUFDO1NBQ1I7UUFDRCxPQUFPLEVBQUU7WUFDUixJQUFJLEVBQUUsU0FBUztZQUNmLEtBQUssRUFBRSxPQUFPO1NBQ2Q7UUFDRCxTQUFTLEVBQUU7WUFDVixJQUFJLEVBQUUsV0FBVztZQUNqQixLQUFLLEVBQUUsTUFBTTtTQUNiO1FBQ0QsTUFBTSxFQUFFO1lBQ1AsSUFBSSxFQUFFLFFBQVE7WUFDZCxLQUFLLEVBQUUsS0FBSztTQUNaO1FBQ0QsTUFBTSxFQUFFO1lBQ1AsSUFBSSxFQUFFLFFBQVE7WUFDZCxLQUFLLEVBQUUsQ0FBQztTQUNSO0tBQ0Q7Q0FDRCxDQUFDO0FBRUYsdUJBQThCLFdBQVcsRUFBRSxRQUFRO0lBQ2xELE1BQU0sQ0FBQyw4QkFBaUIsQ0FBQyxXQUFXLEVBQUUsQ0FBQyxjQUFjLEVBQUUsUUFBUSxDQUFDLENBQUMsQ0FBQztBQUNuRSxDQUFDO0FBRkQsc0NBRUM7QUFBQSxDQUFDIn0=


//////////////////
// WEBPACK FOOTER
// ./~/gpml2pvjson/lib/label.js
// module id = 709
// module chunks = 0